/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_10Inputs */



/**
* | output |
* | --- |
* | "Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****" |
*
* @param {Signup_Feature_Pro_10Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_10 = /** @type {((inputs?: Signup_Feature_Pro_10Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_10Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	if (locale === "de") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	if (locale === "it") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	if (locale === "es") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
	return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****")
});